import { Timestamp } from 'firebase/firestore';
import type { VacationBalance, VacationRequest } from '../../../models/vacation.types';

export const TOUR_DEMO_BALANCE: VacationBalance = {
    collaboratorId: 'demo',
    collaboratorEmail: 'demo@rarolabs.com.br',
    balanceDays: 30,
    expiredDays: 0,
    pastLimitDays: 0,
    availableDays: 30,
    scheduledDays: 0,
    pendingDays: 0,
    pendingSoldDays: 0,
    eligible: true,
    monthsWorked: 24,
    entitledFrom: new Date(new Date().getFullYear() - 2, 0, 10).toISOString().split('T')[0],
    admissionDate: new Date(new Date().getFullYear() - 2, 0, 10).toISOString().split('T')[0],
    nextDeadline: new Date(new Date().getFullYear() + 1, 0, 10).toISOString().split('T')[0],
    nextLegalDeadline: new Date(new Date().getFullYear() + 1, 1, 10).toISOString().split('T')[0],
    periods: [],
    calculatedAt: Timestamp.now(),
    legacyTakenDays: 0,
    legacyScheduledDays: 0,
    legacyInvalidCount: 0,
    unallocatedDays: 0,
};

export function buildTourDemoRequest(today: Date): VacationRequest {
    const startDate = new Date(today);
    startDate.setDate(startDate.getDate() + 60);
    const start = startDate.toISOString().split('T')[0];

    const endDate = new Date(startDate);
    endDate.setDate(endDate.getDate() + 29);
    const end = endDate.toISOString().split('T')[0];

    return {
        id: 'demo-request-id',
        collaboratorId: 'demo',
        collaboratorEmail: 'demo@rarolabs.com.br',
        createdAt: Timestamp.now(),
        updatedAt: Timestamp.now(),
        requestedAt: Timestamp.now(),
        status: 'PendingManager',
        modality: '30',
        totalDays: 30,
        segments: [
            {
                order: 1,
                startDate: start,
                endDate: end,
                days: 30,
                approved: null,
            },
        ],
        managerEmail: 'gestor@rarolabs.com.br',
        managerApproval: {
            status: 'Pending',
            by: null,
            at: null,
            note: null,
        },
        clientEmails: null,
        clientApproval: {
            status: 'None',
            by: null,
            at: null,
        },
        sellRequest: {
            requested: false,
            days: 0,
            status: 'None',
        },
        dpApproval: {
            status: 'Pending',
            by: null,
            at: null,
        },
        correction: null,
        rejectionReason: null,
        timeline: [],
    } as unknown as VacationRequest;
}
